// - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Angular
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

(function() {

    /**
     * @requires angular-resource.js
     */
    angular.module(
        'app',
        [
            'angularSpectrumColorpicker',
            'mm.foundation',
            'app.controller',
            'app.factory',
            'ngFileUpload',
            'ngRoute',
            'ngAnimate',
            'rzModule',
            'slickCarousel'
        ],
        config
    );

    function config($interpolateProvider, $locationProvider, $routeProvider) {
        $interpolateProvider.startSymbol('{[');
        $interpolateProvider.endSymbol(']}');

        $locationProvider.html5Mode({enabled: false, requireBase: false, rewriteLinks: true});

        $routeProvider
                .when('/order', {controller: 'OrderController', templateUrl: 'order/create', resolve: {
                    productCategory: function(ProductCategoryFactory) {
                        return ProductCategoryFactory.get({id: 1}).$promise;
                    }
                }})
                .when('/tyvek', {controller: 'OrderController', templateUrl: 'order/create', resolve: {
                    productCategory: function(ProductCategoryFactory) {
                        return ProductCategoryFactory.get({id: 2}).$promise;
                    }
                }})
                .when('/shape', {controller: 'ShapeController', templateUrl: 'order/createShape', resolve: {
                    productCategory: function(ProductCategoryFactory) {
                        return ProductCategoryFactory.get({id: 3}).$promise;
                    }
                }})
                .when('/checkout', {controller: 'CheckoutController', templateUrl: 'order/checkout.partial'})
                .otherwise('/order');
    }

    // Initialize the factories list on our app.
    angular.module('app.factory', ['ngResource']);

    // Initialize the controllers list on our app.
    angular.module('app.controller', []);

})();
